import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { useTooltip } from '@frontend/design-system';

type Props = {
  children: React.ReactNode;
};

export const Warning = ({ children }: Props) => {
  const { Tooltip, tooltipProps, triggerProps } = useTooltip();

  return (
    <>
      <span
        css={{
          verticalAlign: 'middle',

          ':focus': {
            outline: 'none',
          },

          svg: {
            fill: theme.colors.neutral50,
            transition: 'fill 200ms ease-in-out',
          },

          ':hover svg, :focus svg': {
            fill: theme.colors.primary50,
          },
        }}
        {...triggerProps}
      >
        <Icon name='alert' />
      </span>
      <Tooltip {...tooltipProps}>{children}</Tooltip>
    </>
  );
};
